function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// The 2.8.8 version of dropdown.js patched from https://github.com/xamey/Fomantic-UI-LESS/blob/2.9.0-temp
// Downloaded from https://github.com/xamey/Fomantic-UI-LESS/blob/2.9.0-temp/definitions/modules/dropdown.js
import "../vendor/dropdown.js";
import FuiModuleModifier from "./fui-module";
export default class FuiDropdownModifier extends FuiModuleModifier {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "semanticModuleName", "dropdown");
  }
}